import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import CasovaniDochazkaVypis from "./CasovaniDochazkaVypis";
import CasovaniKlientaAktualni from "./CasovaniKlientaAktualni";
import HledaniKlienta from "./HledaniKlienta";

class KartaKlienta extends Component {
  state = {};

  componentDidMount = () => {
    const { idpobytu } = this.props.match.params;
    if (idpobytu) {
      this.nahrajKartu();
    }
  };

  componentDidUpdate = () => {
    const { idpobytu } = this.state;
    if (
      this.props.match.params.idpobytu &&
      idpobytu !== this.props.match.params.idpobytu
    ) {
      this.nahrajKartu();
    }
  };

  nahrajKartu = async () => {
    const { idpobytu } = this.props.match.params;
    const karta = await httpService.post(
      config.apiEndpoint + "casovani/casovaniKlienta.php",
      { idpobytu }
    );
    this.setState({ idpobytu, loaded: true, karta: karta.data });
  };

  navstevaZony = async (zona) => {
    const { idpobytu } = this.state;
    await httpService.post(config.apiEndpoint + "casovani/navstevaZony.php", {
      idpobytu,
      zona,
    });
    this.nahrajKartu();
  };

  spotreba = (col) => {
    const { karta } = this.state;
    const nazev = karta.klient["zona_" + col + "_nazev"];
    const pocet = parseInt(karta.klient["zona_" + col + "_pocet"]);
    const vypis =
      karta.navstevaZony &&
      karta.navstevaZony.findIndex((z) => parseInt(z.zona) === col) >= 0 &&
      karta.navstevaZony.find((z) => parseInt(z.zona) === col).vypis;
    const spotreba = (vypis && vypis.length) || 0;
    return (
      <div className="col-4">
        <div className="card">
          <div className="card-header">{nazev}</div>
          <div className="card-body">
            <div>
              <strong>Nárok celkem:</strong> {pocet}
            </div>
            <div>
              <strong>Spotřebováno:</strong> {spotreba}
            </div>
            {vypis && vypis.length > 0 && (
              <table
                className="table primary-table mt-2"
                style={{ fontSize: "0.8em" }}
              >
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Zapsal</th>
                  </tr>
                </thead>
                <tbody>
                  {vypis.map((v, index) => (
                    <tr key={index}>
                      <td>{new Date(v.datum).toLocaleString()}</td>
                      <td>{v.zapsal}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="card-footer">
            <button
              className="btn btn-primary"
              disabled={!(pocet - spotreba > 0)}
              onClick={() => this.navstevaZony(col)}
            >
              Zapsat návštěvu
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { karta, loaded } = this.state;
    const { idpobytu } = this.props.match.params;
    return (
      <div>
        <HledaniKlienta />
        {loaded ? (
          karta && karta.klient && karta.klient.idpobytu ? (
            <div>
              <h2>{karta.klient.jmeno}</h2>
              <div
                className={
                  karta.klient.stav === "1" ? "text-success" : "text-danger"
                }
              >
                {new Date(karta.klient.prichod).toLocaleDateString()} -{" "}
                {new Date(karta.klient.odchod).toLocaleDateString()} (
                {karta.klient.noci} nocí)
              </div>
              {karta.klient.strediskoNazev}
              <div className="row mt-3">
                {this.spotreba(1)}
                {this.spotreba(2)}
                {this.spotreba(3)}
              </div>
              <hr />
              <h3>Aktuální časování</h3>
              <CasovaniKlientaAktualni idpobytu={karta.klient.idpobytu} />
              <hr />
              <h3>Přehled docházky</h3>
              <CasovaniDochazkaVypis idpobytu={karta.klient.idpobytu} />
            </div>
          ) : (
            <div className="alert alert-danger">Nenalezeno...</div>
          )
        ) : (
          idpobytu && "Loading..."
        )}
      </div>
    );
  }
}

export default KartaKlienta;
